import React, { useContext, useEffect } from "react";
import { Badge, Button, Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import lianghuang from "../../../assets/img/baolinPrivate/2025lianghuang.png";
import { GuestContext } from "../../../contexts/GuestContext";
import { groupLiangHuangSessions, LIANG_HUANG_EVENT } from "../../../config/liangHuang2026";

export default function LiangHuangEventCarousel() {
  const history = useHistory();
  const { language, setPageBanner } = useContext(GuestContext);

  useEffect(() => {
    setPageBanner(2);
  }, [setPageBanner]);

  return (
    <div className="card m-3 shadow-sm-dark overflow-hidden">
      <img src={lianghuang} className="card-img-top" alt={LIANG_HUANG_EVENT.title[language]} />
      <div className="p-3 p-xl-4 bg-white">
        <h3 className="font-weight-bold font-size-lg text-second mb-1">
          {LIANG_HUANG_EVENT.title[language]}
        </h3>
        <p className="font-weight-bold text-info mb-3">{LIANG_HUANG_EVENT.dateRange[language]}</p>
        <p className="text-second mb-4">{LIANG_HUANG_EVENT.description[language]}</p>

        <div className="mb-4">
          {groupLiangHuangSessions().map((group) => {
            const first = group.sessions[0];
            return (
              <div key={group.dateKey} className="border-bottom py-3">
                <div className="d-flex flex-wrap align-items-center mb-1">
                  <strong className="mr-2">{first.date[language]}</strong>
                  {first.allDay && <Badge variant="warning">{language === "English" ? "All day" : "全天"}</Badge>}
                  {first.completion && <Badge variant="success" className="ml-2">{language === "English" ? "Completion ceremony" : "總圓滿大法會"}</Badge>}
                </div>
                {group.sessions.map((session) => (
                  <div key={session.field} className="text-second">
                    {language === "English" ? `Scroll ${session.scroll}` : `卷${["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"][session.scroll - 1]}`}
                    {": "}{session.time}
                  </div>
                ))}
              </div>
            );
          })}
        </div>

        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <Button variant="warning" className="font-weight-bold" block onClick={() => history.push("/register")}>
              {language === "English" ? "Register" : "我要報名"}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
}
